import { render, staticRenderFns } from "./checkPayResult.vue?vue&type=template&id=73588589&scoped=true&"
import script from "./checkPayResult.vue?vue&type=script&lang=js&"
export * from "./checkPayResult.vue?vue&type=script&lang=js&"
import style0 from "./checkPayResult.vue?vue&type=style&index=0&id=73588589&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73588589",
  null
  
)

export default component.exports